import { footerMenu } from "@/constants/footer";
import useOpenExternalUrl from "@/lib/hooks/useOpenExternalUrl";
import classNames from "classnames";

const FooterMenu = ({ className }: { className?: string }) => {
  const openUrl = useOpenExternalUrl();

  return (
    <div
      className={classNames(
        "grid grid-cols-2 sm:flex items-start flex-wrap justify-between gap-6 min-w-min",
        className
      )}
    >
      {footerMenu?.map((section, index) => (
        <div key={index} className="flex flex-start flex-col gap-5">
          <h3 className="text-base font-semibold">{section?.title}</h3>
          <div className="flex items-start flex-col gap-3">
            {section?.menu?.map((mn, menuIndex) => (
              <button
                key={menuIndex}
                className="text-start text-sm font-medium text-slate-400 hover:text-slate-200 transition-all"
                onClick={() => openUrl(mn?.path)}
              >
                {mn?.title}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FooterMenu;
